import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { UtcDateToUserTimeZonePipe } from './shared/entities/utc-date-to-user-time-zone.pipe';
import { ScrollableDirective } from './shared/directives/scrollable.directive';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from './shared/services/loader.service';
import { LoaderInterceptor } from './shared/services/loader-interceptor.service';
import { LoadingBarModule } from "@ngx-loading-bar/core";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { TranslatePipe } from './shared/entities/translate.pipe';
import { ClientRegisterComponent } from './client-register/client-register.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ArchwizardModule } from 'angular-archwizard';
import { TermAndConditionsComponent } from './term-and-conditions/term-and-conditions.component';
import { CampaignRulesComponent } from './campaign-rules/campaign-rules.component';




@NgModule({
  declarations: [
    AppComponent,
    UtcDateToUserTimeZonePipe,
    ScrollableDirective,
    TranslatePipe,
    ClientRegisterComponent,
    TermAndConditionsComponent,
    CampaignRulesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgSelectModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    PaginationModule.forRoot(),
    NgbModule,
    LoadingBarModule,
    LoadingBarRouterModule,
    LoadingBarHttpClientModule,
    BrowserAnimationsModule,
    ArchwizardModule
  ],
  providers: [
    LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
